module.exports = __webpack_public_path__ + "img/lock-icon-test.946fae9f.png";